import { render, staticRenderFns } from "./IconSquareLeft.vue?vue&type=template&id=bd225dda"
import script from "./IconSquareLeft.vue?vue&type=script&lang=js"
export * from "./IconSquareLeft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports